<template>
  <div :class="`container qs${qsNumber}`" :id="`qs${qsNumber}`">
    <div class="titleBlock">
      <div v-if="content.titleIcon" class="iconBlock">
        <img class="titleIcon" :src="content.titleIcon">
      </div>
      <h1 class="mainTitle">{{ content.mainTitle }}</h1>
      <p v-if="content.subTitle" class="subTitle">{{ content.subTitle }}</p>
    </div>
    <div class="contentBlock" ref="contentBlock">
      <div class="mShow">
        <div class="btnBlock" v-if="content.btn">
          <div class="btnBlockCol" v-for="(row, rowIndex) in content.btn" :key="rowIndex">
            <div
            v-for="(item, index) in row"
            :key="index">
              <Btn 
                :key="btnKey"
                :btn="item" 
                :type="content.componentsType.mobile" 
                :qsNumber="qsNumber"
                @click.native="clickHandler(item)" 
                @navigate="navigate"
              />
            </div>
          </div>
        </div>
        <Input 
          v-if="content.hasInput" 
          :inputValue="$store.state.qsData[qsNumber] && $store.state.qsData[qsNumber].input" 
          placeholder="Enter others" 
          type="normal" 
          v-model.trim="qsData.input" 
          @input="inputHandler()"
        />

        <Input 
          v-if="navigateType === 'INPUT_SUBMIT'" 
          :inputValue="$store.state.qsData[qsNumber] && $store.state.qsData[qsNumber].input" 
          type="navigate" 
          :nextPage="nextPage" 
          v-model.trim="qsData.input" 
          @input="inputHandler()" 
          @navigate="navigate"
        />
      </div>

      <div class="pcShow">
        <div :class="'btnBlock' + (content.layout? ' '+content.layout: '')" v-if="content.btn">
          <div :class="'btnBlockRow' + (content.componentsType.pc? ` ${content.componentsType.pc}Row`: '')" v-for="(row, rowIndex) in content.btn" :key="rowIndex">
            <div
            v-for="(item, index) in row"
            :key="index">
              <Btn 
                :key="btnKey"
                :btn="item" 
                :type="content.componentsType.pc" 
                :qsNumber="qsNumber"
                @click.native="clickHandler(item)" 
                @navigate="navigate"
              />
            </div>
          </div>
        </div>
        <Input 
          v-if="content.hasInput" 
          :inputValue="$store.state.qsData[qsNumber] && $store.state.qsData[qsNumber].input" 
          placeholder="Enter others" 
          type="normal" 
          :layout="content.layout"
          v-model.trim="qsData.input" 
          @input="inputHandler()"
        />

        <Input 
          v-if="navigateType === 'INPUT_SUBMIT'" 
          :inputValue="$store.state.qsData[qsNumber].input" 
          type="navigate" 
          :nextPage="nextPage" 
          v-model.trim="qsData.input" 
          @input="inputHandler()" 
          @navigate="navigate"
        />
      </div>
    </div>
    <Btn 
      v-if="navigateType === 'CLICK_NEXT'"
      :key="btnKey"
      type="nextBtn"
      :btn="{link: nextPage}"
      :canNotClick="canNotClick"
      @navigate="navigate()"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import Input from '@/components/Input.vue'
import Btn from '@/components/Btn.vue'
export default {
  name: "QuestionBody",
  props: {
    qsNumber: Number,
    nextPage: String,
    navigateType: String,
    content: Object
  },
  components: {
    Input,
    Btn
  },
  data() {
    return {
      qsData: {
        input: '',
        answer: []
      },
      checkedBtn: [],
      operation:[],
      btnKey: 0
    }
  },
  computed:{
    canNotClick(){
      return this.$store.state.qsData[this.qsNumber].answer.length === 0 && this.$store.state.qsData[this.qsNumber].input.length === 0
    }
  },
  beforeMount() {
    if(this.nextPage && this.navigateType === 'CLICK_ANY_BTN'){
      this.content.btn.forEach(row => {
        row.forEach(element => {
          element.link = this.nextPage
        })
      });
    }else if(this.navigateType === 'INPUT_SUBMIT'){
      // this.compile()
    }
  },
  mounted() {
    // 更新已答题数量
    this.$store.commit({
      type: 'changeAnswerQsNumber',
      number: this.qsNumber
    })

    if(this.$store.state.qsData[this.qsNumber]){
      this.qsData = this.$store.state.qsData[this.qsNumber]
    }
    this.inputHandler = _.debounce(this.saveData, 200)
  },
  methods: {
    clickHandler(e){
      if(this.navigateType === 'CLICK_ANY_BTN'){
        // 单选
        this.checkedBtn = [e]

      }else{
        // 多选
        // 判断是否已选过唯一按钮
        let uniqueBtnChecked = false
        this.checkedBtn.forEach(btn => {
          if(btn.unique){uniqueBtnChecked = true}
        });

        let idx = this.checkedBtn.indexOf(e)
        if(idx !== -1){
          // 已选过
          this.checkedBtn.splice(idx, 1)
        }else{
          // 未选过
          // 判断最多选项数量
          if(this.content.mostChoice && this.checkedBtn.length >= this.content.mostChoice){
            this.checkedBtn.shift()
          }
          if(e.unique){
            // 该按钮为唯一按钮
            this.checkedBtn = [e]
          }else if(uniqueBtnChecked){
            // 该按钮不为唯一按钮，但之前选过唯一按钮
            this.checkedBtn = [e]
          }else{
            this.checkedBtn.push(e)
          }
        }

      }
      this.saveData()
    },
    saveData(){
      // 初始化
      this.qsData.answer = []
      this.operation = []

      this.checkedBtn.forEach(item => {
        this.qsData.answer.push(item.text)
        if(item.operation){
          item.operation.split('&').forEach(val => {
            this.operation.push(val.trim())
          })
        }
      });

      // 保存数据
      this.$store.commit({
        type: 'changeQsData',
        id: this.qsNumber,
        data: this.qsData
      })

      // 保存 按钮操作
      this.$store.commit({
        type: 'changeOperationData',
        id: this.qsNumber,
        data: this.operation
      })

      // 强制更新btn组件
      if(this.btnKey === 0){this.btnKey = 1}
    },
    navigate(e){
      // this.$axios.post('https://api-staging.bongmi.com/v1/user_story/5809/click')
      if(this.navigateType === 'CLICK_ANY_BTN'){
        // 单选
        // 回答问卷埋点
        this.$sensors.track('AnswerQuestionnaire', {
          questionnaireId: this.qsNumber,
          FFQSanswer: e,
          input: ''
        })
      }else if(this.navigateType === 'INPUT_SUBMIT'){
        // 输入框提交跳转
        // 回答问卷埋点
        this.$sensors.track('AnswerQuestionnaire', {
          questionnaireId: this.qsNumber,
          FFQSanswer: '',
          input: e
        })
      }else{
        // 多选
        // 回答问卷埋点 逐条上报
        this.qsData.answer.forEach(answer => {
          this.$sensors.track('AnswerQuestionnaire', {
            questionnaireId: this.qsNumber,
            FFQSanswer: answer,
            input: this.qsData.input
          })
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.container{
  max-width: 1580px;
  height: 100vh;
  min-height: 900px;
  position: relative;
  margin: 0 auto;
  box-sizing: border-box;
  // padding-top: var(--pc_header_height);
  padding-bottom: var(--progress_height);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .titleBlock{
    display: flex;
    flex-direction: column;
    align-items: center;
    .iconBlock{
      margin-bottom: 30px;
      .titleIcon{
        width: 63px;
        height: 63px;
      }
    }
    .mainTitle{
      margin-bottom: 76px;
      text-align: center;
      font-size: 40px;
    }
    .subTitle{
      font-size: 23px;
      margin-bottom: 45px;
      white-space: pre-wrap;
      text-align: center;
    }
  }
  .contentBlock{
    .btnBlock{
      display: flex;
      flex-direction: column;
      align-items: center;
      .btnBlockRow{
        display: flex;
        justify-content: flex-start;
        margin-bottom: 20px;
        div{
          margin-right: 100px;
        }
        div:last-of-type{
          margin-right: 0;
        }
      }
      .btnBlockRow:last-of-type{
        margin-bottom: 0;
      }
      .cardBtnRow{
        margin-bottom: 47px;
      }
      .cardRow:last-of-type{
        margin-bottom: 0;
      }
    }
    .layout_center{
      align-items: center;
    }
    .layout_left{
      align-items: flex-start;
    }
  }
}
@media only screen and (max-width: 767px){
  .btnBlock{ 
    display: flex;
  }
  .container{
    padding: 90px 65px 45px 65px;
    height: auto;
    min-height: 101%;
    .titleBlock{
      // height: 80px;
      .mainTitle{
        font-size: 18px;
        text-align: center;
        line-height: 24px;
        margin-bottom: 24px;
      }
      .subTitle {
        font-size: 12px;
        margin-bottom: 20px;
      }
    }
    .btnBlock{
      align-items: center;
      .btnBlockCol{
        display: flex;
        flex-direction: column;
        div{
          margin-bottom: 20px;
        }
      }
    }
  }
}
</style>
